import { dateRangeFilterOptions } from "../../../constants/date-range.filter";
import { RequestState } from "../../../constants/request-state";
import { Rating, Ratings } from "../../enums/Rating";
import { EvalDataItem } from "../../eval/EvalDataItem";
import { FilterDateGroup, FilterSelectGroup, FilterType } from "../../filters/FilterGroup";
import { EntityListState } from "./EntityListState";

export interface EvalState extends EntityListState<EvalDataItem> {
    totalRecordNumber: number;
    currentPageNumber: number;
    pageSize: number;
    exportRequestState: RequestState;
}

export interface EvalFilter {
    date: FilterDateGroup;
    ratings: FilterSelectGroup<Rating>;
    managers: FilterSelectGroup<number>;
}

export enum EvalOrderByColumn {
    EvalDate = 'EvalDate',
}

export const evalFilters = {
    visibleFilters: ['date', 'managers', 'ratings'],
    additionalFilters: [],
    defaultFilter: {
        date: {
            key: 'date',
            type: FilterType.Date,
            visible: true,
            text: 'EVAL Date',
            disabled: false,
            selected: false,
            isApplied: true,
            filter: {
                selectedOption: { ...dateRangeFilterOptions.All, default: true },
                options: {
                    customDateRange: { from: null, to: null },
                },
            },
            acceptableOptions: dateRangeFilterOptions.evalOptions(),
        } as FilterDateGroup,
        ratings: {
            key: 'ratings',
            type: FilterType.Select,
            visible: true,
            isApplied: false,
            disabled: false,
            selected: false,
            text: 'Rtg',
            filter: Ratings.map(v => ({
                value: v,
                text: v,
                selected: false,
                disabled: false,
                visible: true,
            })),
        } as FilterSelectGroup<Rating>,
        managers: {
            key: 'managers',
            withSearch: true,
            type: FilterType.Select,
            visible: true,
            text: 'Manager',
            disabled: false,
            selected: false,
            isApplied: true,
            filter: [],
        } as FilterSelectGroup<number>,
    }
};
